import { Box, Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const homes = [
  {
    id: 1,
    title: 'Home Sales',
    image: '/images/home-1.png',
    link: '/living/homes',
  },
  {
    id: 2,
    title: 'New Homes',
    image: '/images/home-2.jpeg',
    link: '/living/homes/new',
  },
  {
    id: 3,
    title: 'Floor Plans',
    image: '/images/home-3.jpeg',
    link: '/living/homes/floorplans',
  },
  {
    id: 4,
    title: 'Pre-owned Homes',
    image: '/images/home-4.jpeg',
    link: '/living/homes/pre-owned',
  },
];

const useStyles = makeStyles((theme) => ({
  subtitleContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  line: {
    margin: 0,
    height: 2,
    backgroundColor: '#212121',
    width: '180px',
    [theme.breakpoints.down('lg')]: {
      width: '80px',
    },
  },
  subtitle: {
    margin: 0,
    color: '#212121',
    fontFamily: 'Playfair Display',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '28px',
    paddingLeft: '32px',
    paddingRight: '32px',
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      fontSize: '16px',
      lineHeight: '20px',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  title: {
    color: '#212121',
    fontFamily: 'Playfair Display',
    fontSize: '36px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '54px',
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      fontSize: '24px',
      lineHeight: '32px',
    },
  },

  card: {
    cursor: 'pointer',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    overflow: 'hidden',
    boxShadow: '0px 4px 16px rgba(164, 164, 164, 0.41)',
  },
  cardTitle: {
    color: '#384D38',
    textAlign: 'center',
    fontFamily: 'Playfair Display',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '28px',
    margin: '12px 0',
  },
  cardImage: {
    width: '100%',
    objectFit: 'cover',
    height: '210px !important',
    objectPosition: 'top center',
    [theme.breakpoints.up('lg')]: {
      height: '280px !important',
          // minHeight: '300px',

        },
  },
}));

function HomesOfBaywood({ node }) {
  const classes = useStyles();

  return (
    <Box style={{ paddingTop: '50px' }}>
      <Box>
        <Box className={classes.subtitleContainer}>
          <Box className={classes.line} />
          <Typography className={classes.subtitle}>
            An affordable resort-style community
          </Typography>
          <Box className={classes.line} />
        </Box>
        <Typography className={classes.title}>
          Discover the Homes of Baywood
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {homes.map((home) => (
          <Grid item xs={12} sm={6} md={3} key={home.id}>
            <div>
              <Link href={home.link} className={`card-link`}>
              <Box className={classes.card} style={{ position: 'relative', minHeight: "100%" }}>
                <div style={{ position: 'relative', minHeight: "100%" }}>
                <Image
                  src={home.image}
                  alt={home.title}
                  className={classes.cardImage}
                  // fill
                  style={{ objectFit: "cover", width: '100%', height: '100%' }}
                  width={460}
                  height={360}
                />
                <Typography className={classes.cardTitle}>
                  {home.title}
                </Typography>
                </div>
              </Box>
            </Link>
            </div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default HomesOfBaywood;
